import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { isFunction } from "../../../lib/utils";
import { cx } from "../../../lib/theming/Emotion";
export var CommonWrapper = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CommonWrapper, _React$Component);

  function CommonWrapper() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CommonWrapper.prototype;

  _proto.render = function render() {
    var _extractCommonProps = extractCommonProps(this.props),
        _extractCommonProps$ = _extractCommonProps[0],
        className = _extractCommonProps$.className,
        style = _extractCommonProps$.style,
        dataProps = _objectWithoutPropertiesLoose(_extractCommonProps$, ["className", "style"]),
        _extractCommonProps$2 = _extractCommonProps[1],
        children = _extractCommonProps$2.children,
        rest = _objectWithoutPropertiesLoose(_extractCommonProps$2, ["children"]);

    var child = isFunction(children) ? children(rest) : children;
    return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, _extends({
      className: cx(child.props.className, className),
      style: _extends({}, child.props.style, style)
    }, dataProps)) : child;
  };

  return CommonWrapper;
}(React.Component);

var extractCommonProps = function extractCommonProps(props) {
  var common = {};
  var rest = {};

  for (var key in props) {
    if (isCommonProp(key)) {
      // @ts-ignore
      common[key] = props[key];
    } else {
      // @ts-ignore
      rest[key] = props[key];
    }
  }

  return [common, rest];
};

var isCommonProp = function isCommonProp(name) {
  switch (true) {
    case name == 'className':
    case name == 'style':
    case name.indexOf('data-') === 0:
      // все data-атрибуты
      return true;

    default:
      return false;
  }
};